"use client";
import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

const roles = [
  "Super Admin",
  "Univ./Dept. Admin",
  "QP Setter",
  "QP Chairperson",
  "Type Setter",
  "Controller/Director of Exams",
];

const features = [
  "Cloud-based continuous question development",
  "SMEs can upload questions with difficulty classification",
  "Upload entire papers per schema",
  "Password-encrypted storage for all uploaded questions",
  "Supports collaborative workflows across roles",
];

const Qpms = () => {
  return (
    <div className="bg-white text-dark ml-50 mr-50">
      {/* Header Section */}
      <section className=" py-5">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="fw-bold text-primary fs-3"
        >
          Question Paper Management System
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-4 fs-5 text-black"
        >
          A <span className="fw-semibold text-primary">cloud-based</span>{" "}
          solution that enables universities and institutions to seamlessly
          develop, manage, and secure question papers. With end-to-end workflows
          and role-based access, QPMS ensures confidentiality and efficiency in
          exam preparation.
        </motion.p>
      </section>

      {/* Features Section */}
      <section>
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="fw-bold text-black text-center mb-5"
        >
          Key Features
        </motion.h2>

        <div className="row g-4">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              className="col-sm-6 col-md-4 mt-2"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="card shadow-sm border-0 h-100 p-3 d-flex flex-row align-items-start">
                <FaCheckCircle className="text-success me-2 mt-1" />
                <span className="text-black">{feature}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Roles Section */}
      <section className="container py-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-light border-start border-4 border-primary rounded shadow-sm p-4"
        >
          <h3 className="fw-semibold text-primary mb-4 text-center">
            QPMS Application Roles
          </h3>
          <div className="row g-4 text-center">
            {roles.map((role, idx) => (
              <motion.div
                key={idx}
                className="col-sm-6 col-md-4"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.1, duration: 0.6 }}
                viewport={{ once: true }}
              >
                <div className="card shadow-sm border-0 h-100 p-3">
                  <h5 className="text-primary fw-semibold">{role}</h5>
                </div>
              </motion.div>
            ))}
          </div>
          <p className="text-black mt-4 text-center">
            Each role has specific tasks and only those options are available to
            the assigned user. OTP is required if set as mandatory.
          </p>
        </motion.div>
      </section>
    </div>
  );
};

export default Qpms;
